import create from 'zustand';
import { ConsentedParticipantsStoreState } from './useConsentedParticipantsStore.types';

const useConsentedParticipantsStore = create<ConsentedParticipantsStoreState>((set) => ({
  startDate: undefined,
  endDate: undefined,
  setStartDate: (startDate: string) => {
    set(() => {
      return {
        startDate,
      };
    });
  },
  setEndDate: (endDate: string) => {
    set(() => {
      return {
        endDate,
      };
    });
  },
}));

export default useConsentedParticipantsStore;
